/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: ESM Woocommerce to Hubspot Integration
  Author: Wibert Muza
  Author URL: https://esminbound.com
==========================================================================================*/

import firebase from "firebase/app";
import "firebase/auth";
import router from "@/router";
import axios from "@/http/axios/index.js";

export default {
  loginAttempt({ dispatch }, payload) {
    // New payload for login action
    const newPayload = {
      userDetails: payload.userDetails,
      notify: payload.notify,
      closeAnimation: payload.closeAnimation
    };

    // If remember_me is enabled change firebase Persistence
    if (!payload.checkbox_remember_me) {
      // Change firebase Persistence
      firebase
        .auth()
        .setPersistence(firebase.auth.Auth.Persistence.LOCAL)

        // If success try to login
        .then(function() {
          dispatch("login", newPayload);
        })

        // If error notify
        .catch(function(err) {
          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation();

          payload.notify({
            time: 2500,
            title: "Error",
            text: err.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    } else {
      // Try to login
      dispatch("login", newPayload);
    }
  },

  // Normal login
  login({ commit, state, dispatch }, payload) {
    // If user is already logged in notify and exit
    if (state.isUserLoggedIn()) {
      // Close animation if passed as payload
      if (payload.closeAnimation) payload.closeAnimation();

      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });

      router.push("/");

      return false;
    }

    // Try to sigin
    firebase
      .auth()
      .signInWithEmailAndPassword(
        payload.userDetails.email,
        payload.userDetails.password
      )

      .then(
        async result => {
          // Set FLAG username update required for updating username
          let isUsernameUpdateRequired = false;

          // if username is provided and updateUsername FLAG is true
          // set local username update FLAG to true
          // try to update username
          if (payload.updateUsername && payload.userDetails.displayName) {
            isUsernameUpdateRequired = true;
            dispatch("updateUsername", {
              user: result.user,
              username: payload.userDetails.displayName,
              notify: payload.notify,
              isReloadRequired: true
            });
          }

          // if username update is not required
          // just reload the page to get fresh data
          // set new user data in localstorage
          if (!isUsernameUpdateRequired) {
            await axios
              .get(
                `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${result.user.uid}`
              )
              .then(response => {
                if ("error" in response.data) {
                  commit(
                    "UPDATE_USER_INFO",
                    {
                      hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                      woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`,
                      displayName: result.user.providerData[0].displayName,
                      email: result.user.providerData[0].email,
                      photoURL: result.user.providerData[0].photoURL,
                      uid: result.user.uid,
                      received: true
                    },
                    { root: true }
                  );

                  router.push("/sync/configuration");

                  // Close animation if passed as payload
                  if (payload.closeAnimation) payload.closeAnimation();
                } else {
                  commit(
                    "UPDATE_USER_INFO",
                    {
                      hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                      woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`,
                      cards: response.data,
                      displayName: result.user.providerData[0].displayName,
                      email: result.user.providerData[0].email,
                      photoURL: result.user.providerData[0].photoURL,
                      uid: result.user.uid,
                      received: true
                    },
                    { root: true }
                  );

                  router.push(router.currentRoute.query.to || "/");

                  // Close animation if passed as payload
                  if (payload.closeAnimation) payload.closeAnimation();
                }
              })
              .catch(() => {
                commit(
                  "UPDATE_USER_INFO",
                  {
                    hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                    woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`,
                    displayName: result.user.providerData[0].displayName,
                    email: result.user.providerData[0].email,
                    photoURL: result.user.providerData[0].photoURL,
                    uid: result.user.uid,
                    received: true
                  },
                  { root: true }
                );

                router.push("/sync/configuration");

                // Close animation if passed as payload
                if (payload.closeAnimation) payload.closeAnimation();
              });
          }
        },
        err => {
          // Close animation if passed as payload
          if (payload.closeAnimation) payload.closeAnimation();

          payload.notify({
            time: 2500,
            title: "Error",
            text: err.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        }
      );
  },

  // Google Login
  loginWithGoogle({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    const provider = new firebase.auth.GoogleAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async result => {
        await axios
          .get(
            `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${result.user.uid}`
          )
          .then(response => {
            if ("error" in response.data) {
              commit("UPDATE_USER_INFO", {
                hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
              });
            } else {
              commit(
                "UPDATE_USER_INFO",
                {
                  hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                  woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`,
                  cards: response.data,
                  displayName: result.user.providerData[0].displayName,
                  email: result.user.providerData[0].email,
                  photoURL: result.user.providerData[0].photoURL,
                  uid: result.user.uid,
                  received: true
                },
                { root: true }
              );
            }
          })
          .catch(() => {
            commit("UPDATE_USER_INFO", {
              hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
              woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
            });
          });

        router.push(router.currentRoute.query.to || "/");
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  },

  // Facebook Login
  loginWithFacebook({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    const provider = new firebase.auth.FacebookAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async result => {
        await axios
          .get(
            `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${result.user.uid}`
          )
          .then(response => {
            if ("error" in response.data) {
              commit("UPDATE_USER_INFO", {
                hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
              });
            } else {
              commit(
                "UPDATE_USER_INFO",
                {
                  hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                  woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`,
                  cards: response.data,
                  displayName: result.user.providerData[0].displayName,
                  email: result.user.providerData[0].email,
                  photoURL: result.user.providerData[0].photoURL,
                  uid: result.user.uid,
                  received: true
                },
                { root: true }
              );
            }
          })
          .catch(() => {
            commit("UPDATE_USER_INFO", {
              hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
              woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
            });
          });

        router.push(router.currentRoute.query.to || "/");
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  },

  // Twitter Login
  loginWithTwitter({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    const provider = new firebase.auth.TwitterAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async result => {
        await axios
          .get(
            `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${result.user.uid}`
          )
          .then(response => {
            if ("error" in response.data) {
              commit("UPDATE_USER_INFO", {
                hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
              });
            } else {
              commit(
                "UPDATE_USER_INFO",
                {
                  hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                  woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`,
                  cards: response.data,
                  displayName: result.user.providerData[0].displayName,
                  email: result.user.providerData[0].email,
                  photoURL: result.user.providerData[0].photoURL,
                  uid: result.user.uid,
                  received: true
                },
                { root: true }
              );
            }
          })
          .catch(() => {
            commit("UPDATE_USER_INFO", {
              hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
              woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
            });
          });

        router.push(router.currentRoute.query.to || "/");
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  },

  // Github Login
  loginWithGithub({ commit, state }, payload) {
    if (state.isUserLoggedIn()) {
      payload.notify({
        title: "Login Attempt",
        text: "You are already logged in!",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning"
      });
      return false;
    }
    const provider = new firebase.auth.GithubAuthProvider();

    firebase
      .auth()
      .signInWithPopup(provider)
      .then(async result => {
        await axios
          .get(
            `https://us-central1-app-script-243110.cloudfunctions.net/fetch_hubspot_connection_data?userId=${result.user.uid}`
          )
          .then(response => {
            if ("error" in response.data) {
              commit("UPDATE_USER_INFO", {
                hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
              });
            } else {
              commit(
                "UPDATE_USER_INFO",
                {
                  hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
                  woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`,
                  cards: response.data,
                  displayName: result.user.providerData[0].displayName,
                  email: result.user.providerData[0].email,
                  photoURL: result.user.providerData[0].photoURL,
                  uid: result.user.uid,
                  received: true
                },
                { root: true }
              );
            }
          })
          .catch(() => {
            commit("UPDATE_USER_INFO", {
              hubspotConnection: `https://us-central1-app-script-243110.cloudfunctions.net/express/install?userId=${result.user.uid}`,
              woocommerceConnection: `https://us-central1-app-script-243110.cloudfunctions.net/esm_woo_auth?userId=${result.user.uid}`
            });
          });

        router.push(router.currentRoute.query.to || "/");
      })
      .catch(err => {
        payload.notify({
          time: 2500,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  },

  // Register User
  registerUser({ dispatch }, payload) {

    if (payload.userDetails.displayName) {
      axios
        .post(
          `https://us-central1-app-script-243110.cloudfunctions.net/esm_inbound_create_contact_from_esm_woo`,
          {
            displayName: payload.userDetails.displayName,
            lastName: payload.userDetails.lastName,
            companyName: payload.userDetails.companyName,
            email: payload.userDetails.email
          }
        )
    }

    // create user using firebase
    firebase
      .auth()
      .createUserWithEmailAndPassword(
        payload.userDetails.email,
        payload.userDetails.password
      )
      .then(
        result => {
          // if username is provided and updateUsername FLAG is true
          // set local username update FLAG to true
          // try to update username
          if (payload.userDetails.displayName) {
            dispatch("updateUsername", {
              user: result.user,
              displayName: payload.userDetails.displayName,
              isReloadRequired: false
            });
          }

          payload.notify({
            title: "Account Created",
            text: "You are successfully registered!",
            iconPack: "feather",
            icon: "icon-check",
            color: "success"
          });
          const newPayload = {
            userDetails: payload.userDetails,
            notify: payload.notify,
            updateUsername: true
          };
          dispatch("login", newPayload);
        },
        error => {
          payload.notify({
            title: "Error",
            text: error.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        }
      );
  },
  updateUsername({ commit }, payload) {
    payload.user
      .updateProfile({
        displayName: payload.displayName
      })
      .then(() => {
        // If username update is success
        // update in localstorage
        let userInfo = {
          displayName: payload.user.providerData[0].displayName,
          email: payload.user.providerData[0].email,
          photoURL: payload.user.providerData[0].photoURL,
          uid: payload.user.uid
        };
        commit("UPDATE_USER_INFO", userInfo, { root: true });

        // If reload is required to get fresh data after update
        // Reload current page
        if (payload.isReloadRequired) {
          router.push(router.currentRoute.query.to || "/");
        }
      })
      .catch(err => {
        payload.notify({
          time: 8800,
          title: "Error",
          text: err.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger"
        });
      });
  }
};
